(function(){
    angular.module('tmx-app').factory('LoanApplicationService', ['tmxResource','$q','lookupService','cacheStore', '$mdMedia','TMX_FINANCE_CONSTANTS',
        function(tmxResource,$q,lookupService,cacheStore,$mdMedia,TMX_FINANCE_CONSTANTS){
            var applications = tmxResource("LoanApplication");
            var vm = this;
            vm.tenant= APP_CONSTANTS.tenant;
            vm.BVSVerified = false;
            vm.verifiedCustomer={};
            vm.BVSError="";
            var vitasTenants = ["vitas","vitas-leb","vitas-eg","vitasiraq"];
            vm.fullNameColumnhide = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? true : false;
            vm.fullNameColumnshow = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? false : true;
            var transactionStatusLkps = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.TransactionStatus).map(x=>({VisibleValue:x.VisibleValue,HiddenValue:x.VisibleValue}));

            applications.lebTranslationModelMapping = {
                "FirstName":"FirstName", "MiddleName":"FatherName","LastName":"LastName", "MotherName":"MotherName","EnglishName":"EnglishName",
                "CdrFirstName":"CDRFirstName","CdrFatherName":"CDRFatherName","CdrFamilyName":"CDRFamilyName","CdrMotherName":"CDRMotherName",
                "MotherFamilyName":"MotherFamilyName","CdrMotherFamilyName":"CDRMotherFamilyName"
            };
            

            applications.lebVmToGuarantorMapping = {
                "FirstName":"TmxPerson.PersonFirstName", "MiddleName":"TmxPerson.PersonMiddleName","LastName":"TmxPerson.PersonLastName", 
                "MotherName":"MotherName","EnglishName":"EnglishName",
                "CdrFirstName":"CdrFirstName","CdrFatherName":"CdrFatherName","CdrFamilyName":"CdrFamilyName","CdrMotherName":"CdrMotherName",
                "MotherFamilyName":"MotherFamilyName","CdrMotherFamilyName":"CdrMotherFamilyName"
            };

            applications.fetchExistingCustomer = function(cnic) {
                return  tmxResource("Integration").getByAction("GetETB/"+cnic, true, 'get');
            }
            applications.fetchCustomerByCNIC = function(cnic) {
                return  tmxResource("CustomerMaster").getByAction("GetByCnic/"+cnic + "/" + "AllData", false, 'get');
            }
            applications.calculateLSA = function(LSAModel) {
                return  tmxResource("CustomerMaster").getByAction("CalculateLSA", false,'post',LSAModel);
            }
            applications.getTabEntityMapping = function() {
                if(cacheStore.get("TabEntityMapping")) {
                    return cacheStore.get("TabEntityMapping");
                }
                else {
                    return  tmxResource("Entity").getByAction("TabEntityMapping/", true, 'get').then(function(response) {
                        cacheStore.set("TabEntityMapping", angular.copy(response.data));
                    });
                }                        
            }

            applications.searchApplicationByNumber = function(applicationNumber) {
                return applications.getByAction("GetApplicationsByApplicationNumber/"+applicationNumber, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.data.forEach(item=>{
                            if(item['TmxCustomerMaster'].length > 0) {
                                item['CustomerName'] = item['TmxCustomerMaster'][0]['CustomerName'];
                                item['CustomerCode'] = item['TmxCustomerMaster'][0]['CustomerCode'] == null?'N/A': item['TmxCustomerMaster'][0]['CustomerCode'];
                            }
                            else {
                                item['CustomerName'] = 'N/A';
                                item['CustomerCode'] = 'N/A';
                            }                                                    
                        })
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.searchApplicationbyParams = function(param, ProductId) {
                return applications.getByAction("SearchSecondaryApprovedApps/"+ProductId+"/"+param, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.getExistingApplicationDetails = function(existingApp) {
                return applications.getByAction("GetExistingApplicationDetails", false,'post',existingApp);
            }

            applications.fetchEcib = function(obj) {
                return  tmxResource("Integration").getByAction("GeteCIBData", false, 'post',obj);
            }

            applications.getEligibility = function(obj) {
                return applications.getByAction("getEligibility",false,'post',obj);
            }

            applications.CancelById = function(loanApplicationId) {
                return  applications.getByAction("CancelById/"+loanApplicationId, false, 'put',{});
            }

            applications.getWorkflowStatesByProductId = function (ProductId) {
                return applications.getByAction("WorkflowStates/" + ProductId, true);
            };

            applications.getChecklistHistory = function (applicationId, productChecklistId) {
                return applications.getByAction("GetChecklistHistory/" + applicationId + "/" + productChecklistId, true);
            };
            applications.getGuarantorChecklistHistory = function (guarantorId, productChecklistId) {
                return applications.getByAction("GetGuarantorChecklistHistory/" + guarantorId + "/" + productChecklistId, true);
            };
            applications.getTimeFrames = function(){
             
                return applications.getByAction("GetTimeFrameParameterForReport",false);
            };

            applications.postImage = function(obj){
             
                return applications.getByAction("UploadFile",false,'post',obj);
            };

            applications.reassignApplication = function(array) {
                return applications.getByAction("BulkReassignTask",false,'put',array);
            }

            applications.getloanappjobstatus = function(){
             
                return applications.getByAction("PostLoanApplicationStatus",false);
            };

            applications.getCommandsByProcessId = function(processId){
             
                return applications.getByAction("GetCommandsByProcessId/"+processId,true);
            };

            applications.createLoanApplication = function(data){
             
                return applications.getByAction("",false,'post',data);
            };

            applications.getEcibDetail = function(){
                return tmxResource("enquiry/GeteCIBData").getById("3520268380749",true);

            }

            applications.executeTransactionWF = function(targetController,data){
                return tmxResource(targetController).getByAction("ExecuteWf", false,'put',data);
            }

            applications.getApplicationById = function(id){
                tmxResource("LoanApplication").getById(id).then(function(response){                 
                    return response;
                });
            }

            applications.deleteById = function(id) {
                var deferred = $q.defer();
                tmxResource("LoanApplication").getById(id).then(function(result) {
                    deferred.resolve(result.$remove());
                });
                return deferred.promise;
            };

            applications.setApplicationState = function(data){
                return  tmxResource("LoanApplication").getByAction("SetApplicationState", false, 'put',data);
            }

            var loanAppSearchGridStatus =[] ;
            lookupService.getLoanApplicationStatusLkp().then(function(LoanApplicationStatus){
                LoanApplicationStatus.forEach(function(loanAppStatusLookup) {
                    loanAppSearchGridStatus.push({
                        "HiddenValue":loanAppStatusLookup.HiddenValue,
                        "VisibleValue":loanAppStatusLookup.VisibleValue
                    });
                });
            });

            applications.searchGridColumns = [      
                {
                    field: "Select",
                    title: "Select",
                    type: "text",
                    headerTemplate: "{{'Select' | translate}}",
                    template: "<input type='radio' ng-click='LoanApplicationAddCtrl.applicationSelectChange(dataItem)' id='application' name='application' ng-checked='dataItem.LoanApplicationId == LoanApplicationAddCtrl.selectedApplicationId && LoanApplicationAddCtrl.selectedApplicationId'>",
                },
                {
                    field: "LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    headerTemplate: "{{'LoanApplicationNumber' | translate}}"
                },
                {
                    field: "LoanProductId",
                    title: "LoanProductId",
                    type: "text",
                    headerTemplate: "{{'ProductName' | translate}}",
                    template:"{{LoanApplicationAddCtrl.getProductNameById(dataItem['LoanProductId']) }}",
                },
                {
                    field: "ClientReferenceNumber",
                    title: "ClientReferenceNumber",
                    type: "text",
                    headerTemplate: "{{'Client Reference Number' | translate}}"
                },
                {
                    field: "CustomerName",
                    title: "CustomerName",
                    type: "text",
                    headerTemplate: "{{'CustomerName' | translate}}"
                },
                {
                    field: "CustomerCode",
                    title: "CustomerCode",
                    type: "text",
                    headerTemplate: "{{'CustomerCode' | translate}}"
                },
                {
                    field: "ApplicationStatusLkp",
                    title: "ApplicationStatusLkp",
                    type: "text",
                    template: "{{LoanApplicationAddCtrl.getVisibleValueByLookupId(dataItem.ApplicationStatusLkp)}}",
                    headerTemplate: "{{'Status' | translate}}"
                }
            
            ];

            applications.gridColumns = [
                {
                    field:"LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('LoanApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanApplicationNumber\")' ></i></span>"
                },
                {
                    field:"FullName",
                    title: "Customer",
                    type: "alpha",
                    search: vm.fullNameColumnhide,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('FullName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"FullName\")' ></i></span>",
                    template: "<div>{{dataItem.FullName | defaultValue}} </div> <span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span> ",
                    hidden: vm.fullNameColumnshow,
                    usePattern:false
                },
                {
                    field:"CustomerName",
                    title: "Customer",
                    type: "alpha",
                    search: vm.fullNameColumnshow,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "<div>{{dataItem.CustomerName | defaultValue}} </div> <span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span>",
                    hidden: vm.fullNameColumnhide,
                    usePattern:false
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Cnic",
                    type: "numeric",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    template: "<span class='nowrap'>{{dataItem.NationalIdentifierValue | cnic}}</span>"

                },
                {
                    field:"ProductName",
                    title:"Product",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"BranchName",
                    title:"Branch ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('BranchName')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"CreatorName",
                    title:"Creator",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('CreatorName')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"CreatorName\")' ></i></span>",
                    template:"<div>{{dataItem.CreatorName}}</div><span class='subtitle-wrap '>{{ dataItem.Creator }}</span>",   
                },
                {
                    field:"InboxName",
                    title:"Assigned To",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('InboxName')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"InboxName\")' ></i></span>",
                    template:"<div>{{dataItem.InboxName}}</div><span class='subtitle-wrap '>{{ dataItem.InboxUser }}</span><br><span ng-if='dataItem.InboxName!=null' class='subtitle-wrap'><b>{{ dataItem.TransitionTime }}</b></span>",                  
                },  
                {
                    field:"LoanAssignedCredit",
                    title:"Loan Credit",
                    type: "text",
                    search: true,  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('LoanAssignedCredit')}\" >{{'LoanAssignedCredit' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanAssignedCredit\")' ></i></span>",
                },           
                {
                    field:"LoanApplicationDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    template: "<span >{{dataItem.FormattedLoanApplicationDate}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('LoanApplicationDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanApplicationDate\")' ></i></span>"
                }, //
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
                },
                {
                    template: "<md-menu flex='none' class='menu-list-item' md-position-mode=\"target-right target\" md-offset='-20 60'>"
                                    +"<md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>"
                                        +"<md-menu-content width='2' >"
                                            +"<md-menu-item><md-button ng-disabled='LoanApplicationCtrl.deleteEntityPermission' aria-label='del' class='tmxMin'  ng-click='LoanApplicationCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Cancel</md-button></md-menu-item>"
                                            +"<md-menu-item><md-button ng-disabled='LoanApplicationCtrl.assignEntityPermission' aria-label='del' class='tmxMin'  ng-click='LoanApplicationCtrl.clickAssign(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>assignment</md-icon>Assign</md-button></md-menu-item>"
                                        +"</md-menu-content>"
                                +"</md-menu>",
                }
            ];

            applications.repaymentGridColumns = [
                {   
                    width: $mdMedia('gt-sm') ? '6%' : '150px',
                    headerTemplate:"",
                    template: "<md-checkbox ng-disabled='!LoanRepaymentCtrl.editPermission' style='top: 10px;' ng-change='LoanRepaymentCtrl.applicationChecked(dataItem)' ng-model='dataItem.Selected' />",
                },
                {
                    field:"LoanRepaymentDetailId",
                    title: "LoanRepaymentDetailId",
                    type: "text",
                    search: false,
                    template: "{{dataItem.LoanRepaymentDetailId}}",
                    hidden: true,
                    usePattern:false
                },
                {
                    field:"ClientReferenceNumber",
                    title: "LoanNumber",
                    type: "alpha",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('ClientReferenceNumber')}\" >{{'LoanNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>",
                    template: "<div>{{dataItem.ClientReferenceNumber}} </div> <span class='subtitle-text'>{{dataItem.TMXLoanApplicationNumber}}</span> ",
                    usePattern:false
                },
                {
                    field:"PaymentNumber",
                    title: "PaymentNumber",
                    type: "text",
                    search: true,
                    isNumber: true, 
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaymentNumber')}\" >{{'PaymentNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentNumber\")' ></i></span>",
                    template: "<span class='nowrap'>{{dataItem.PaymentNumber}}</span>"

                },
                {
                    field:"CustomerName",
                    title:"CustomerName",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.CustomerName}}'>{{ dataItem.CustomerName}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"CustomerName\")' ></i></span>"
                },
                {
                    field:"BranchCode",
                    title:"Branch ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('BranchCode')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"BranchCode\")' ></i></span>"
                },
                {
                    field:"LOUser",
                    title:"LoanOfficer",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('LOUser')}\" >{{'LoanOfficer' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"LOUser\")' ></i></span>",
                    template:"<div>{{dataItem.LOUser}}</div><span class='subtitle-wrap '>{{ dataItem.LOFullName }}</span>",   
                },
                {
                    field:"TotalPaymentDueUSD",
                    title:"PaymentDueUSD",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('TotalPaymentDueUSD')}\" >{{'PaymentDueUSD' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"TotalPaymentDueUSD\")' ></i></span>",
                    template: "{{LoanRepaymentCtrl.formatAmount(dataItem.TotalPaymentDueUSD)}}",                 
                },
                {
                    field:"ManualReceiptNumber",
                    title:"ManualReceiptNumber",
                    type: "alpha",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('ManualReceiptNumber')}\" >{{'ManualReceiptNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"ManualReceiptNumber\")' ></i></span>",                 
                }, 
                {
                    field:"PaymentDate",
                    title:"PaymentDate",
                    type: "date",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaymentDate')}\" >{{'PaymentDate' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentDate\")' ></i></span>", 
                    template:"{{LoanRepaymentCtrl.formatDate(dataItem.PaymentDate)}}"                
                }, 
                {
                    field:"PaidAmount",
                    title:"PaidAmount",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaidAmount')}\" >{{'PaidAmountUSD' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaidAmount\")' ></i></span>",  
                    template: "{{LoanRepaymentCtrl.formatAmount(dataItem.PaidAmount)}}",                
                },  
                {
                    field:"TransactionNumber",
                    title:"TransactionNumber",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('TransactionNumber')}\" >{{'TransactionNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"TransactionNumber\")' ></i></span>",                 
                },           
                {
                    field:"PaymentStatus",
                    title:"PaymentStatus",
                    type: "select",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaymentStatus')}\" >{{'PaymentStatus' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentStatus\")' ></i></span>",
                    data: transactionStatusLkps,
                }
            ];

            applications.repaymentFilterColumns = [

                {
                    field:"ClientReferenceNumber",
                    title: "LoanNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('ClientReferenceNumber')}\" >{{'LoanNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>"

                },
                {
                    field:"PaymentNumber",
                    title: "PaymentNumber",
                    type: "numeric",
                    search: true,
                    isNumber: true, 
                    filterOperator: 'eq',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaymentNumber')}\" >{{'PaymentNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentNumber\")' ></i></span>",
                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    usePattern:false
                
                },
                {
                    field:"BranchCode",
                    title: "BranchCode",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('BranchCode')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"BranchCode\")' ></i></span>",
                    template: "{{dataItem.BranchCode}} "


                },
                {
                    field:"LOUser",
                    title:"LoanOfficer",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('LOUser')}\" >{{'LoanOfficer' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"LOUser\")' ></i></span>"

                },            
                {
                    field:"TotalPaymentDueUSD",
                    title:"PaymentDueUSD ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('TotalPaymentDueUSD')}\" >{{'PaymentDueUSD' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"TotalPaymentDueUSD\")' ></i></span>"
                },
                {
                    field:"ManualReceiptNumber",
                    title:"ManualReceiptNumber",
                    type: "alpha",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('ManualReceiptNumber')}\" >{{'ManualReceiptNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"ManualReceiptNumber\")' ></i></span>"
                },           
                {
                    field:"PaymentDate",
                    title:"PaymentDate",
                    type: "date",
                    search: true,
                    applySearchRangeForThisDate:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active':LoanRepaymentCtrl.isFiltered('PaymentDate')}\" >{{'PaymentDate' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentDate\")' ></i></span>"
                },
                {
                    field:"PaidAmount",
                    title:"PaidAmountUSD",
                    type: "text",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaidAmount')}\" >{{'PaidAmountUSD' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaidAmount\")' ></i></span>"
                },
                {
                    field:"TransactionNumber",
                    title:"TransactionNumber",
                    type: "text",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('TransactionNumber')}\" >{{'TransactionNumber' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"TransactionNumber\")' ></i></span>"
                },
                {
                    field:"PaymentStatus",
                    title:"PaymentStatus",
                    type: "select",
                    filterOperator: 'eq', 
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanRepaymentCtrl.isFiltered('PaymentStatus')}\" >{{'PaymentStatus' | translate}}<i class='fa fa-filter' ng-if='LoanRepaymentCtrl.isFiltered(\"PaymentStatus\")' ></i></span>",
                    data: transactionStatusLkps,
                }
            ];

            applications.cols = [

                {
                    field:"LoanApplicationNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('LoanApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanApplicationNumber\")' ></i></span>"

                },
                {
                    field:"FullName",
                    title: "CustomerName",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('FullName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"FullName\")' ></i></span>",
                    hidden: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    usePattern:false
                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    hidden: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    usePattern:false
                
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Cnic",
                    type: "numeric",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    template: "{{dataItem.NationalIdentifierValue}} "


                },
                {
                    field:"ProductName",
                    title:"Product",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"ProductName\")' ></i></span>"

                },            
                {
                    field:"BranchName",
                    title:"LoanBranch ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('BranchName')}\" >{{'LoanBranch' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"Creator",
                    title:"Creator",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"Creator\")' ></i></span>"
                },
                {
                    field:"InboxUser",
                    title:"InboxUser",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"InboxUser\")' ></i></span>"
                },            
                {
                    field:"LoanApplicationDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    applySearchRangeForThisDate:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active':LoanApplicationCtrl.isFiltered('LoanApplicationDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"LoanApplicationDate\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "text",                
                    isNumber: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LoanApplicationCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='LoanApplicationCtrl.isFiltered(\"Status\")' ></i></span>"
                }
            ];

            applications.ecibCols = [
                {
                    field: "MRDate",
                    title: "MRDate",
                    headerTemplate: "<span>{{'MRDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.MRDate)}}</p>"
                },
                {
                    field: "FDate",
                    title: "FDate",
                    headerTemplate: "<span>{{'FDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.FDate)}}</p>"
                }
                ,
                {
                    field: "AsOfDate",
                    title: "AsOfDate",
                    headerTemplate: "<span>{{'AsOfDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.AsOfDate)}}</p>"
                },
                {
                    field: "Balance",
                    title: "Balance",
                    headerTemplate: "<span>{{'Balance' | translate}}</span>",
                    template:"<p>{{dataItem.Balance}}</p>"
                },
                {
                    field: "Limit",
                    title: "Limit",
                    headerTemplate: "<span>{{'Limit' | translate}}</span>",
                    template:"<p>{{dataItem.Limit}}</p>"
                },
                {
                    field: "Product",
                    title: "Product",
                    headerTemplate: "<span>{{'Product' | translate}}</span>",
                    template:"<p>{{dataItem.Product}}</p>"
                },
                {
                    field: "IsDefaulter",
                    title: "IsDefaulter",
                    headerTemplate: "<span>{{'IsDefaulter' | translate}}</span>",
                    template:"<p>{{dataItem.IsDefaulter}}</p>"
                },
                {
                    field: "TermLoanOrEvergreen",
                    title: "TermLoanOrEvergreen",
                    headerTemplate: "<span>{{'TermLoanOrEvergreen' | translate}}</span>",
                    template:"<p>{{dataItem.TermLoanOrEvergreen}}</p>"
                },
                {
                    field: "TypeOfLoan",
                    title: "TypeOfLoan",
                    headerTemplate: "<span>{{'TypeOfLoan' | translate}}</span>",
                    template:"<p>{{dataItem.TypeOfLoan}}</p>"
                },
                {
                    field: "Bank",
                    title: "Bank",
                    headerTemplate: "<span>{{'Bank' | translate}}</span>",
                    template:"<p>{{dataItem.Bank}}</p>"
                },
                {
                    field: "ProductName",
                    title: "ProductName",
                    headerTemplate: "<span>{{'ProductName' | translate}}</span>",
                    template:"<p>{{dataItem.ProductName}}</p>"
                },
                {
                    field: "PositionAsOf",
                    title: "PositionAsOf",
                    headerTemplate: "<span>{{'PositionAsOf' | translate}}</span>",
                    template:"<p>{{LoanApplicationAddCtrl.formatDate(dataItem.PositionAsOf)}}</p>"
                },
                {
                    field: "WriteOff",
                    title: "WriteOff",
                    headerTemplate: "<span>{{'WriteOff' | translate}}</span>",
                    template:"<p>{{dataItem.WriteOff}}</p>"
                },
                {
                    field: "DateOfWriteOff",
                    title: "DateOfWriteOff",
                    headerTemplate: "<span>{{'DateOfWriteOff' | translate}}</span>",
                    template:"<p>{{LoanApplicationAddCtrl.formatDate(dataItem.DateOfWriteOff)}}</p>"
                }
      
                ,
                {
                    field: "Overdue30Plus",
                    title: "Overdue30Plus",
                    headerTemplate: "<span>{{'Overdue30Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue30Plus}}</p>"
                }
                ,
                {
                    field: "Overdue60Plus",
                    title: "Overdue60Plus",
                    headerTemplate: "<span>{{'Overdue60Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue60Plus}}</p>"
                }
                ,
                {
                    field: "Overdue90Plus",
                    title: "Overdue90Plus",
                    headerTemplate: "<span>{{'Overdue90Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue90Plus}}</p>"
                }
                ,
                {
                    field: "Overdue90Plus",
                    title: "WriteOff",
                    headerTemplate: "<span>{{'WriteOff' | translate}}</span>",
                    template:"<p>{{dataItem.WriteOff}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy30Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy30Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy30Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy30Plus}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy60Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy60Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy60Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy60Plus}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy90Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy90Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy90Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy90Plus}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy1To15Days",
                    title: "NoOfTimesPaymentWereMadeLateBy1To15Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy1To15Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy1To15Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy16To20Days",
                    title: "NoOfTimesPaymentWereMadeLateBy16To20Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy16To20Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy16To20Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy21To29Days",
                    title: "NoOfTimesPaymentWereMadeLateBy21To29Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy21To29Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy21To29Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy30Days",
                    title: "NoOfTimesPaymentWereMadeLateBy30Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy30Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy30Days}}</p>"
                }    
            ];


            return applications;

        }]);
})();